import ArticleGalleryCard from './ArticleGalleryCard';

export default class ArticleGalleryCardResponse {
  constructor(
    public status: number,
    public data: ArticleGalleryCard[],
    public error?: Error
  ) {}
}
